import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function SpeedPolicy() {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <section
                className="what-Offer blog speed-policy"
                style={{ backgroundImage: "url('images/speed-policy.png')" }}
            >
                <div className="container">
                    <div className="blog-top-text">
                        <p className="r4l-kicker">{t('header.nav.speedPolicy')}</p>
                        <h2 dangerouslySetInnerHTML={{ __html: t('r4l.promise.title') }} />
                    </div>
                </div>
            </section>

            <section className="recent-blog speed">
                <div className="container">
                    <h3 className="heading">{t('speedPolicy.speedAndFairUsage')}</h3>

                    <div className="table-policy">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">{t('speedPolicy.table.planType')}</th>
                                    <th scope="col">{t('speedPolicy.table.speedBeforeFUP')}</th>
                                    <th scope="col">{t('speedPolicy.table.fairUsagePolicy')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className='unlimited-plan'>
                                        <span>
                                            <img src={window.getPublicUrl('images/table-icon1.svg')} alt="" />
                                        </span>
                                        <p>{t('speedPolicy.table.unlimitedPlans')}</p>
                                        </div>
                                    </td>
                                    <td>{t('speedPolicy.table.upTo4G5G')}</td>
                                    <td>{t('speedPolicy.table.mayReduceAfter500MB')}</td>
                                </tr>
                                <tr>
                                    <td>
                                          <div className='unlimited-plan'>
                                        <span>
                                            <img src={window.getPublicUrl('images/table-icon2.svg')} alt="" />
                                        </span>
                                        <p>{t('speedPolicy.table.dataBundles')}</p>
                                        </div>
                                    </td>
                                    <td>{t('speedPolicy.table.fullSpeed4G')}</td>
                                    <td>{t('speedPolicy.table.noSpeedReduction')}</td>
                                </tr>
                                <tr>
                                    <td>
                                          <div className='unlimited-plan'>
                                        <span>
                                            <img src={window.getPublicUrl('images/table-icon3.svg')} alt="" />
                                        </span>
                                        <p>{t('speedPolicy.table.globalESIMs')}</p> 
                                        </div>
                                    </td>
                                    <td>{t('speedPolicy.table.regionBased3G4G')}</td>
                                    <td>{t('speedPolicy.table.noSpeedReduction')}</td>

                                    {/* <td>{t('speedPolicy.table.speedReducesAfter20GB')}</td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="what-policy">
                        <h3>{t('speedPolicy.whatIsFUP.title')}</h3>
                        <p>
                            {t('speedPolicy.whatIsFUP.description')}
                        </p>
                    </div>

                    <div className="row">
                        <div className="col-sm-4">
                            <div className="factor">
                                <h3>{t('speedPolicy.factors.title')}</h3>
                                <ul>
                                    <li>{t('speedPolicy.factors.location')}</li>
                                    <li>{t('speedPolicy.factors.timeOfDay')}</li>
                                    <li>{t('speedPolicy.factors.partnerNetworks')}</li>
                                    <li>{t('speedPolicy.factors.deviceCompatibility')}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="factor">
                                <h3>{t('speedPolicy.speedTips.title')}</h3>
                                <ul>
                                    <li>{t('speedPolicy.speedTips.turnOffAutoUpdates')}</li>
                                    <li>{t('speedPolicy.speedTips.useWiFiForDownloads')}</li>
                                    <li>{t('speedPolicy.speedTips.monitorDataUsage')}</li>
                                    <li>{t('speedPolicy.speedTips.purchaseTopUp')}</li>
                                    <li>{t('speedPolicy.speedTips.keepMobileDataOnWhenNeeded')}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="factor need">
                                <h3>{t('speedPolicy.needMoreSpeed.title')}</h3>
                                <p>
                                    {t('speedPolicy.needMoreSpeed.description')}
                                </p>
                                <button onClick={() => setShowModal(true)}>{t('speedPolicy.needMoreSpeed.topUpNow')}</button>
                                {/* <button>{t('speedPolicy.needMoreSpeed.checkAvailablePlans')}</button> */}
                            </div>
                        </div>
                    </div>

                    <div className="still">
                        <div className="still-left">
                            <h2>{t('speedPolicy.stillHaveQuestions.title')}</h2>
                            <p>
                                {t('speedPolicy.stillHaveQuestions.description')}
                            </p>
                        </div>
                        <Link to="/Faq">
                        <button className='faq-page'>{t('speedPolicy.stillHaveQuestions.visitFAQPage')}</button>
                        </Link>
                        <Link to="/contactUs">
                        <button className='contact'>{t('speedPolicy.stillHaveQuestions.contactSupport')}</button></Link>
                        
                    </div>
                </div>
            </section>

            {/* App Download Modal */}
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>{t('appDownloadModal.title')}</h3>
                            <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <p>{t('appDownloadModal.description')}</p>
                            <ul className="app-btn">
                                <li>
                                    <a href="https://apps.apple.com/in/app/roam4less-esim-travel-data/id6756699233" target="_blank" rel="noopener noreferrer">
                                        <img src={window.getPublicUrl('images/app-store.png')} alt={t('appDownloadModal.appStore')} />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=com.roam4less.app&hl=en_IN" target="_blank" rel="noopener noreferrer">
                                        <img src={window.getPublicUrl('images/google-play.png')} alt={t('appDownloadModal.googlePlay')} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}

export default SpeedPolicy;
